import Container from '@mui/material/Container';
import Box from "@mui/material/Box";
import {ReactNode} from "react";
import ErrorsCatcher from '@/components/ErrorsCatcher/Tsx/ErrorsCatcher';

const Page = ({children, noMaxWidth = false}: { children: ReactNode | ReactNode[], noMaxWidth?: boolean }) => {

    return (
        <Container maxWidth={noMaxWidth ? false : "xl"} sx={{pb: 3,}}>
            <Box sx={{paddingTop: 2,}}>
                <ErrorsCatcher errorId="ea09f2e6-e017-4777-b764-dcc1b4cb0435">
                    {children}
                </ErrorsCatcher>
            </Box>
        </Container>
    )
};

export default Page;
